import MuiButton from "./MuiButton";
import MuiIconButton from "./MuiIconButton";
import MuiPaper from "./MuiPaper";
import MuiTableCell from "./MuiTableCell";
import MuiTableHead from "./MuiTableHead";
import MuiTypography from "./MuiTypography";
import MuiDataTable from "./MuiDataTable";
import MuiDataTableCell from "./MuiDataTableCell";

const _obj = {
  MuiButton: MuiButton,
  MuiIconButton: MuiIconButton,
  MuiPaper: MuiPaper,
  MuiTableCell: MuiTableCell,
  MuiTableHead: MuiTableHead,
  MuiTypography: MuiTypography,
  MUIDataTable: MuiDataTable,
  MUIDataTableBodyCell: MuiDataTableCell,
};

export default _obj;
